import axios from 'axios'
import { Message } from 'element-ui'

const actions = {
  getUser: ({commit}) => {
    return new Promise( (resolve, reject) => {
      axios.get('/api/user/info').then((result) => {
        if (result.data.code === 200 && result.data.data) {
          let data = result.data.data;
          commit('SAVE_USER_INFO', {
            name: data.nickName,
            logoPic: data.logoPic,
            isOperator: data.isOperator,
            isDubAnchor: data.isDubAnchor
            // 获取用户主播身份状态
          });
          commit('SET_ANCHOR_STATUS', {
            level: data.anchorGrade,
            type: data.verifyType
          })
          resolve();
        } else {
          reject();
        }
      }).catch((error) => {
        Message({
          type: 'error',
          message: error.message
        })
        reject();
      })
    })
  },
  getStatus: ({commit}) => {
    return new Promise( (resolve, reject) => {
      // 获取用户作家身份状态
      axios.get('/api/author/status').then((result) => {
        if (result.data.code === 406) {
          this.$message({
            type: 'warning',
            message: result.data.message,
            duration: 1500
          });
          reject();
        } else if (result.data.code === 200) {
          if (result.data.data) {
            commit('SET_USER_STATUS', {
              authorProgressStatus: result.data.data.auditStatus,
              authorProgressLabel: result.data.data.auditLabel,
              type: result.data.data.authorType,
              typeLabel: result.data.data.authorTypeLabel,
              rejectionReason: result.data.data.rejectReason
            });
            resolve();
          } else {
            commit('SET_USER_STATUS', {
              authorProgressStatus: 0,
              authorProgressLabel: '未认证',
              type: 0,
              typeLabel: '',
              rejectionReason: ''
            });
            reject();
          }
        }
      })
    })
  }
}

export default actions



// WEBPACK FOOTER //
// ./src/store/actions.js